import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const LoadPicture = (type) => {

    const [data, setData] = useState(null);

    const getData = useCallback(() => {

        if (type !== null) {

            axios({
                method: 'get',
                url: `https://script.google.com/macros/s/AKfycbwAMX25yxw_aksB3VkTlN_pbn4_oj0WD861BZtnz810kMql9IyXieflQ36Ofm58CPjnoA/exec?id=2&hcode=${type}`,
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then((res) => {

                    if (res.data && res.data) {
                        setData(res.data);
                    }

                })
                .catch((error) => {

                    console.error('Error fetching data:', error.message);

                })

        }

    }, [type])

    useEffect(() => {

        getData();

    }, [getData]);

    return data;
};

export default LoadPicture;
